'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isMap;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isMap.js
// module id = 814
// module chunks = 0